import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ecommercearrow() {
  return (
    <section
      className="ecommerce_arrow p-100 text_white"
      style={{ background: "#000" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/arrow/ecommerce_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={481}
              height={775}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>Tekrevol – Your Partner In E-commerce Platform Development</h2>
            <p>
              Tekrevol offers a lot more than just Android or iPhone app
              development solutions. We are an integrated tech firm that can
              provide you with a range of custom tech based solutions applicable
              across multiple industry verticals.
            </p>
            <p>
              Working through the initial scope, our development and design team
              can pull off visually stunning displays along with a bug-free back
              end in order to deliver a superlative final product that serves
              all of your inherent needs with the platform.
            </p>
            <p>
              If you have a similar idea for E-commerce based platform
              development, we can be your partner in this journey and even white
              label our existing product frameworks to lower the cost for the
              overall product that you need to get built.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercearrow;
